import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

export type MwArrowToggleState = 'expanded' | 'collapsed';

@Component({
  selector: 'mw-arrow-toggler',
  templateUrl: './arrow-toggler.component.html',
  styleUrls: ['./arrow-toggler.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('collapsed', style({ transform: 'rotate(0)' })),
      state('expanded', style({ transform: 'rotate(-180deg)' })),
      transition('collapsed => expanded', animate('400ms ease-out')),
      transition('expanded => collapsed', animate('400ms ease-in')),
    ]),
  ],
})
export class MwArrowTogglerComponent {
  @Input() state: MwArrowToggleState = 'collapsed';
  @Input() removeHover = false;
  @Output() toggle = new EventEmitter<MwArrowToggleState>();
  constructor() {}
  onToggle(): void {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    this.toggle.emit(this.state);
  }
}
